const PhoneIcon = '/assets/saopaulo/General/BusesSaoPaulo-Website-Header-PhoneIcon.svg';
const PopupIcon = '/assets/saopaulo/about/aboutus.jpg';

const BookingInActive = '/assets/chilebus/Home/ChileBus-Website-Home-SearchBar-BuyTicket.svg';
const CancelInActive = '/assets/chilebus/Home/ChileBus-Website-Home-SearchBar-CancelTicket.svg';
const BookingActive = '/assets/chilebus/buy-grey.svg';
const CancelActive = '/assets/chilebus/cancel-grey.svg';
const OriginIcon = '/assets/chilebus/Home/ChileBus-Website-Home-SearchBar-OriginIcon.svg';
const DestinationIcon =
	'/assets/chilebus/Home/ChileBus-Website-Home-SearchBar-DestinationIcon-01.svg';
const CalendarIcon = '/assets/chilebus/Home/ChileBus-Website-Home-SearchBar-CalendarIcon-01.svg';
const pnr = '/assets/chilebus/General/ChileBus-Website-WhereToFindMyPNR.svg';
const SearchIcon = '/assets/saopaulo/Home/SearchBar-SearchIcon.svg'
// Title icons

const titleLeftIcon = '/assets/chilebus/General/ChileBus-Website-FavIcon.svg';
const titleRightIcon = '/assets/chilebus/General/ChileBus-Website-FavIcon.svg';

const ContactBg = '/assets/chilebus/Home/ChileBus-Website-Home-Background-ContactSection.png';

// footerIcons

const contactFb = '/assets/chilebus/Contact/facebook.svg';
const insta = '/assets/saopaulo/General/BusesSaoPaulo-Website-Footer-SocialMedia-Instagram.svg';

// const contactFb = '/assets/chilebus/Contact/ChileBus-Website-Contact-SocialMedia-Facebook.svg';
const contactInsta =
	'/assets/chilebus/Contact/instagram.svg';
const operatorPay = '/assets/santamaria/SMPaypng.png'
// banners
const destinationBanner =
	'/assets/chilebus/destinations/destinations-banner.png';
const contactUsBanner = '/assets/chilebus/Contact/contact-banner.png';
const aboutUsBanner = '/assets/chilebus/company/company-banner.webp';
const tncBanner = '/assets/chilebus/tnc/tnc.webp';
const officeBanner = '/assets/chilebus/offices/offices-banner-image.png';
// const aboutUsSecondBanner =
//   '/assets/saopaulo/about-us/BusesSaoPaulo-Website-TheCompany-BannerHistory.jpg';

const aboutUsImage = '/assets/chilebus/company/aboutus.webp';
const userIcon = '/assets/chilebus/Blue/user_red_dot.svg';
const contactMail = '/assets/chilebus/Contact/email.svg';
const contactHeadphone =
	'/assets/chilebus/offices/headphone.svg';

const pin = '/assets/chilebus/offices/pin.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';



const trips = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';

const paso_1 = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const paso_2 = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-RechargePoints-Blue.svg';
const paso_3 = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-ID-Blue.svg';
const paso_4 = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-Tickets-Blue.svg';

const success = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';

const tick = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';
const otp = '/assets/chilebus/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';
const chilebusIcons = [
	{ icon: operatorPay, name: 'operatorPay' },
	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: PopupIcon, name: 'Popup' },
	{ icon: PhoneIcon, name: 'phone' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: BookingInActive, name: 'BIA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: CalendarIcon, name: 'Calendar' },
	{ icon: pnr, name: 'pnr' },

	// Title icons
	{ icon: titleLeftIcon, name: 'titleLeftIcon' },
	{ icon: titleRightIcon, name: 'titleRightIcon' },

	{ icon: ContactBg, name: 'ContactBg' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	// footerIcons
	{ icon: contactFb, name: 'contactFb' },
	{ icon: insta, name: 'insta' },

	// { icon: contactFb, name: 'contactFb' },
	{ icon: contactInsta, name: 'contactInsta' },

	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },
	// { icon: aboutUsSecondBanner, name: 'aboutUsSecondBanner' },

	{ icon: contactMail, name: 'contactMail' },
	{ icon: contactHeadphone, name: 'contactHeadphone' },

	{ icon: aboutUsImage, name: 'aboutUsImage' },

	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: animation, name: 'animation' },
	{ icon: pnr, name: 'pnr' },
	{ icon: pin, name: 'pin' },
	{ icon: SearchIcon, name: 'SearchIcon' },
];

export default chilebusIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/chilebusIcons.js